//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'c_select',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    number: {
      type: null
    }
  },
  data: function data() {
    return {
      defaults: {},
      configData: {},
      timeStamp: '',
      multiple: false,
      selectId: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
      _this.selectId = _this.configData.activeValue;
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
        this.selectId = this.configData.activeValue; // 选中的值
      },
      deep: true
    },
    number: function number(nVal) {
      this.timeStamp = nVal;
    }
  },
  methods: {
    sliderChange: function sliderChange(e) {
      var storage = window.localStorage;
      this.configData.activeValue = e;
      //   this.configData.activeValue = e ? e : storage.getItem(this.timeStamp);
      this.$emit('getConfig', {
        name: 'select',
        values: e
      });
    }
  }
};